import { mergeStyles } from "@fluentui/merge-styles";
import { BORDER_COLOR, LINK_COLOR } from "../../../../config/colors";
import { FONT_SIZE_VSMALL, FONT_SIZE_REGULAR } from "../../../../config/fontSizes";

export const wrapperClasses = mergeStyles({
  border: `1px solid ${BORDER_COLOR}`,
  padding: 10,
  display: "flex",

  "&:hover": {
    boxShadow: "2px 1px 4px rgba(0,0,0, 0.3)",
  },
});

export const asideClasses = mergeStyles({
  width: 30,
  flexShrink: 0,
});

export const bodyClasses = mergeStyles({
  width: "calc(100% - 30px)"
});

export const changesSummaryClasses = mergeStyles({
  color: LINK_COLOR,
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
  "&:hover": {
    textDecoration: "underline",
  },
});

export const changesSummaryWrapperClasses = mergeStyles({
  marginBottom: 10,
});

export const titleClasses = mergeStyles({
  color: "#000",
  fontSize: FONT_SIZE_REGULAR,
  marginBottom: 6,
  textDecoration: "none",

  "&:hover": {
    color: LINK_COLOR,
  },
});
export const descriptionClasses = mergeStyles({
  color: "#6e6c69",
  fontSize: FONT_SIZE_VSMALL,
  marginTop: 6,
  marginBottom: 6,
  whiteSpace: 'pre-wrap',
});

export const saveStackClasses = mergeStyles({
  display: "flex",
  flexDirection: "column",
  gap: 7,
});
